<template>
	<div
		v-if="ready"
		class="container"
	>

		<div class="row center">
			<div class="col-lg-8 col-md-12">
				<h1 class="main-content-title">
					{{ translations.navigation.environment }}
				</h1>
			</div>
		</div>

		<div class="row center">
			<div class="col-lg-8 col-md-12">
				<div class="box">
					<div class="box-head with-line">
						<div class="box-head-text">
							{{ translations.labels.environmentText }}
						</div>
					</div>
					<div class="box-body">
						<el-form :model="form" ref="form">
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label>
										{{ translations.labels.apiPath }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item>
										<el-input
											v-model="form.apiPath"
											type="text"
											disabled
										/>
									</el-form-item>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-3 col-sm-12">
									<label>
										{{ translations.labels.stripeKey }}
									</label>
								</div>
								<div class="col-lg-9 col-sm-12">
									<el-form-item>
										<el-input
											v-model="form.stripeKey"
											type="textarea"
											disabled
										/>
									</el-form-item>
								</div>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'Environment',
	metaInfo () {
		return {
			title: this.translations.navigation.environment
		}
	},
	data () {
		return {
			form: {
				apiPath: process.env.VUE_APP_API,
				stripeKey: process.env.VUE_APP_STRIPE
			}
		}
	},
	mounted () {
		this.removeLoader()
	}
}
</script>
